export { NileDetail } from './nile-detail';